import React from 'react'
import { Routes, Route, Navigate, useLocation, useNavigationType } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './components/Layout'
import Home from './pages/Home'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Profile from './pages/Profile'
import Dashboard from './pages/Dashboard'
import OmOs from './pages/OmOs'
import Community from './pages/Community'
import Calendar from './pages/Calendar'
import Articles from './pages/Articles'
// Assuming Article is exported from the same file or should be Articles
import Article from './pages/Article'
import AdminSetup from './pages/AdminSetup'
import Features from './pages/Features'
import AdminRoute from './components/AdminRoute'

import ProtectedRoute from './components/ProtectedRoute'

import { isTokenValid } from './utils/auth'

function ScrollToTop() {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();

    useEffect(() => {
        if (navigationType !== 'POP') {
            window.scrollTo(0, 0);
        }
    }, [pathname, navigationType]);

    return null;
}

function HomePage() {
    const [isAuthed, setIsAuthed] = React.useState(() => Boolean(localStorage.getItem('token')))

    useEffect(() => {
        const syncAuth = () => setIsAuthed(Boolean(localStorage.getItem('token')))
        window.addEventListener('auth-changed', syncAuth)
        window.addEventListener('storage', syncAuth)
        return () => {
            window.removeEventListener('auth-changed', syncAuth)
            window.removeEventListener('storage', syncAuth)
        }
    }, [])

    return isAuthed ? <Dashboard /> : <Home />
}

// Fixed: Wrapped the floating logic and JSX into the App component
export default function App() {
    // On app load, check token validity.
    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (token && !isTokenValid(token)) {
            localStorage.removeItem('token');
            localStorage.removeItem('role');
            localStorage.removeItem('publicName');
            window.dispatchEvent(new Event('auth-changed'));
            if (window.location.pathname !== '/') {
                window.location.replace('/');
            }
        }
    }, []);

    return (
        <Layout>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />

                <Route path="/dashboard" element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                } />

                <Route path="/OmOs" element={<OmOs />} />

                <Route path="/community" element={
                    <ProtectedRoute>
                        <Community />
                    </ProtectedRoute>
                } />
                <Route path="/community/:slug" element={
                    <ProtectedRoute>
                        <Community />
                    </ProtectedRoute>
                } />

                <Route path="/calendar" element={
                    <ProtectedRoute>
                        <Calendar />
                    </ProtectedRoute>
                } />

                <Route path="/articles" element={<Articles />} />
                <Route path="/article/:id" element={<Article />} />

                <Route path="/funktioner" element={<Features />} />

                <Route path="/admin-setup" element={
                    <AdminRoute>
                        <AdminSetup />
                    </AdminRoute>
                } />

                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Layout>
    );
}